import styles from './ModalForm.module.css';

const ModalForm = ({children, visible, setVisible, noCloseButton}) => {

    const className = visible ? `${styles.modalForm} ${styles.active}` : styles.modalForm;

    return (
        <div className={className}>
            <div className={styles.modalFormContent}>
                <div /*style={{marginBottom: "50px"}}*/>
                    {children}
                </div>
                {!noCloseButton && <button className={styles.close_icon} onClick={() => {
                    setVisible(false)
                }}></button>}
            </div>
        </div>
    );
};

export default ModalForm;